import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faMapMarkerAlt, faHospital, faUserAlt, faBoxes, faTruck, faTruckLoading, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useReactToPrint } from 'react-to-print';

//Components
import TabelaListagemFichas from '../../components/TabelaListagemFichas/TabelaListagemFichas';
import MainCard from '../../components/MainCard/MainCard';

//Helpers
import mascaras from '../../helpers/mascaras';

//Context
import { useAuth } from '../../context/auth';

export default function FichaPgrss({ pgrssForm, editar = null, btnEditar = null }) {
    const { setupVariavel, session } = useAuth();
    //referencia do relatorio
    const refRelatorio = useRef();

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "PGRSS",
    });

    //Cabeçalhos da tabela de transportadores
    const headersTabelaTransportadores = [
        { value: "Nome", objectValue: "fantasia" },
        { value: "Licença ambiental", objectValue: "licencaAmbiental" },
    ]

    //Estado que guarda os dados do pgrss
    const [pgrss, setPgrss] = useState(pgrssForm);

    return (
        <MainCard noCard={editar == null ? false : true} title={" "} btnEditarInTop={btnEditar != null ? btnEditar : null} btnImprimir={btnEditar != null ? handlePrint : null} >
            {pgrss &&
                <div className="mt-4 relatorio w-100" ref={refRelatorio} style={{ color: "#666" }}>
                    <div className="print m-2 d-flex align-items-center justify-content-between">
                        <p>Emitido por: {session.nome}</p>
                        <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                    </div>
                    <div className="body">
                        {setupVariavel?.logoTipo &&
                            <div className="d-flex align-items-center justify-content-center">
                                <img src={"data:image/png;base64," + setupVariavel?.logoTipo} width={250} />
                            </div>
                        }
                        <h3 className='text-center mb-4 text-dark fw-bold mt-4'>Plano de Gerenciamento de Resíduos de Serviços de Saúde</h3>
                        <h5 className='bg-secondary p-1 rounded-3 text-light d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faPencilAlt} /> Identificação do estabelecimento</span>{editar ? <button className='btnEditFicha' onClick={() => editar(1)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
                        <div className='row'>
                            <div className='col-4'>
                                <p><span className="fw-bold">Razão Social: </span> {pgrss.gerador.razao}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Nome Fantasia: </span> {pgrss.gerador.fantasia}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Atividade exercida: </span> {pgrss.gerador.segmento}</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4'>
                                <p><span className="fw-bold">CNPJ: </span> {mascaras.cnpjMask(pgrss.gerador.cnpj)}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">E-mail: </span> {pgrss.gerador.email}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Telefone: </span> {mascaras.celularMask(pgrss.gerador.telefone)}</p>
                            </div>

                        </div>
                        <div className='row'>
                            <div className='col-4'>
                                <p><span className="fw-bold">Número do cadastro no CGRSS: </span> {pgrss.cgrss}</p>
                            </div>
                            <div className='col-5'>
                                <p><span className="fw-bold">Data do início ou previsão de funcionamento:  </span> {pgrss.funcionamento != "" ? moment(new Date(pgrss.funcionamento)).format("DD/MM/YYYY") : "Não informado"}</p>
                            </div>
                            <div className='col-3'>
                                <p><span className="fw-bold">Propriedade: </span> {pgrss.gerador.categoria}</p>
                            </div>
                        </div>
                        <h5 className='bg-secondary p-1 rounded-3 text-light mt-4'><FontAwesomeIcon icon={faMapMarkerAlt} /> Localização do Estabelecimento</h5>
                        <div className='row'>
                            <div className='col-4'>
                                <p><span className="fw-bold">CEP:  </span> {mascaras.cepMask(pgrss.gerador.cep)}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">UF: </span> {pgrss.gerador.uf}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Cidade: </span> {pgrss.gerador.cidade}</p>
                            </div>

                        </div>
                        <div className='row'>
                            <div className='col-4'>
                                <p><span className="fw-bold">Bairro: </span> {pgrss.gerador.bairro}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Logradouro: </span> {pgrss.gerador.logradouro}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Numero: </span> {pgrss.gerador.numero}</p>
                            </div>

                        </div>
                        <h5 className='bg-secondary p-1 rounded-3 text-light mt-4 d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faHospital} /> Caracterização do Estabelecimento</span></h5>
                        <div className='row'>
                            <div className='col-6'>
                                <p><span className="fw-bold">Número de funcionários (inclusive sócios): </span> {pgrss.qtdFuncionarios}</p>
                            </div>
                            <div className='col-6'>
                                <p><span className="fw-bold">Condição de funcionamento do estabelecimento: </span> {pgrss.condicaoFuncionamento}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-6'>
                                <p><span className="fw-bold">Horário de Funcionamento: </span> {pgrss.horarioFuncionamento}</p>
                            </div>
                            <div className='col-6'>
                                <p><span className="fw-bold">Dias de funcionamento: </span> {pgrss.diasFuncionamento && pgrss.diasFuncionamento.map((value, index) => {
                                    return (value.label + (index !== pgrss.diasFuncionamento.length - 1 ? ", " : ""));
                                })}</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4'>
                                <p><span className="fw-bold">Alvará sanitário: </span> {pgrss.alvaraSanitario}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Número: </span> {pgrss.alvaraSanitarioNumero}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Validade: </span> {pgrss.alvaraSanitarioValidade}</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-4'>
                                <p><span className="fw-bold">Licença ambiental: </span> {pgrss.licencaAmbiental}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Número: </span> {pgrss.licencaAmbientalNumero}</p>
                            </div>
                            <div className='col-4'>
                                <p><span className="fw-bold">Validade: </span> {pgrss.licencaAmbientalValidade}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-12'>
                                <p><span className="fw-bold">Nome da empresa responsável pelo PCMSO (PROGRAMA DE CONTROLE MÉDICO DE SAÚDE OCUPACIONAL): </span> {pgrss.empresaPCMSO}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-12'>
                                <p><span className="fw-bold">Nome da empresa que presta serviço de controle de pragas: </span> {pgrss.empresaControlePragas}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-12'>
                                <p><span className="fw-bold">Alvará sanitário da empresa que presta serviço de controle de pragas:  </span> {pgrss.empresaControlePragasAlvara}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-12'>
                                <p><span className="fw-bold">Possui rotinas de Biossegurança, descritas e implantadas?  </span> {pgrss.RotinasBiosseguranca}</p>
                            </div>
                        </div>
                        <div className="contentGroup">
                            <h5 className='bg-secondary p-1 rounded-3 text-light mt-4 d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faUserAlt} /> Identificação do Responsável Legal pelo Estabelecimento</span>{editar ? <button className='btnEditFicha' onClick={() => editar(2)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Nome: </span> {pgrss.respEstabelecimentoNome}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">E-mail: </span> {pgrss.respEstabelecimentoEmail}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Telefone: </span> {pgrss.respEstabelecimentoTelefone}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">CEP: </span> {mascaras.cepMask(pgrss.respEstabelecimentoCep)}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Cidade: </span> {pgrss.respEstabelecimentoCidade}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Bairro: </span> {pgrss.respEstabelecimentoBairro}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Logradouro: </span> {pgrss.respEstabelecimentoLogradouro}</p>
                                </div>
                            </div>
                        </div>
                        <div className="contentGroup">
                            <h5 className='bg-secondary p-1 rounded-3 text-light mt-4 d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faUserAlt} /> Identificação do Responsável Técnico pela Elaboração do PGRSS</span>{editar ? <button className='btnEditFicha' onClick={() => editar(2)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Nome: </span> {pgrss.elaboracaoPGRSSNome}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">E-mail: </span> {pgrss.elaboracaoPGRSSEmail}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Telefone: </span> {pgrss.elaboracaoPGRSSTelefone}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">CEP: </span> {mascaras.cepMask(pgrss.elaboracaoPGRSSCep)}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Cidade: </span> {pgrss.elaboracaoPGRSSCidade}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Bairro: </span> {pgrss.elaboracaoPGRSSBairro}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Logradouro: </span> {pgrss.elaboracaoPGRSSLogradouro}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Identificação profissional: </span> {pgrss.elaboracaoPGRSSIdentProfissional}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Identificação ART: </span> {pgrss.elaboracaoPGRSSART}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Número Conselho de Classe: </span> {pgrss.elaboracaoPGRSSConselhoClasse}</p>
                                </div>
                            </div>
                        </div>
                        <div className="contentGroup">
                            <h5 className='bg-secondary p-1 rounded-3 text-light mt-4 d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faUserAlt} /> Identificação do Responsável Técnico pelo Gerenciamento do PGRSS</span> {editar ? <button className='btnEditFicha' onClick={() => editar(2)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Nome: </span> {pgrss.gerenciamentoPGRSSNome}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">E-mail: </span> {pgrss.gerenciamentoPGRSSEmail}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Telefone: </span> {pgrss.gerenciamentoPGRSSTelefone}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">CEP: </span> {mascaras.cepMask(pgrss.gerenciamentoPGRSSCep)}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Cidade: </span> {pgrss.gerenciamentoPGRSSCidade}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Bairro: </span> {pgrss.gerenciamentoPGRSSBairro}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Logradouro: </span> {pgrss.gerenciamentoPGRSSLogradouro}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4">
                                    <p><span className="fw-bold">Identificação profissional: </span> {pgrss.gerenciamentoPGRSSIdentProfissional}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Identificação ART: </span> {pgrss.gerenciamentoPGRSSART}</p>
                                </div>
                                <div className="col-4">
                                    <p><span className="fw-bold">Número Conselho de Classe: </span> {pgrss.gerenciamentoPGRSSConselhoClasse}</p>
                                </div>
                            </div>
                        </div>
                        <h5 className='bg-secondary p-1 rounded-3 text-light mt-4 d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faBoxes} /> Dados Sobre a Geração e o Armazenamento de Resíduos</span> {editar ? <button className='btnEditFicha' onClick={() => editar(3)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Quantidade total de resíduos gerados por mês (KG): </span> {mascaras.floatMask(pgrss.totalResiduosMes)}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Tipo de recipiente de acondicionamento para resíduos do grupo A: </span> {pgrss.recipienteGrupopA}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Tipo de recipiente de acondicionamento para resíduos do grupo B: </span> {pgrss.recipienteGrupopB}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Tipo de recipiente de acondicionamento para resíduos do grupo C: </span> {pgrss.recipienteGrupopC}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Tipo de recipiente de acondicionamento para resíduos do grupo D: </span> {pgrss.recipienteGrupopD}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Tipo de recipiente de acondicionamento para resíduos do grupo E: </span> {pgrss.recipienteGrupopE}</p>
                            </div>
                        </div>
                        <h5 className='bg-secondary p-1 rounded-3 text-light mt-4 d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faTruckLoading} /> Dados Sobre a Coleta de Resíduos</span>{editar ? <button className='btnEditFicha' onClick={() => editar(4)}><FontAwesomeIcon icon={faEdit} /></button> : <></>}</h5>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Frequência da coleta dos resíduos do grupo A: </span> {pgrss.frequenciaGrupoA}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Horários da coleta dos resíduos do grupo A: </span> {pgrss.horarioGrupoA}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Frequência da coleta dos resíduos do grupo B: </span> {pgrss.frequenciaGrupoB}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Horários da coleta dos resíduos do grupo B: </span> {pgrss.horarioGrupoB}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Frequência da coleta dos resíduos do grupo C: </span> {pgrss.frequenciaGrupoC}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Horários da coleta dos resíduos do grupo C: </span> {pgrss.horarioGrupoC}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Frequência da coleta dos resíduos do grupo D: </span> {pgrss.frequenciaGrupoD}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Horários da coleta dos resíduos do grupo D: </span> {pgrss.horarioGrupoD}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Frequência da coleta dos resíduos do grupo E: </span> {pgrss.frequenciaGrupoE}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <p><span className="fw-bold">Horários da coleta dos resíduos do grupo E: </span> {pgrss.horarioGrupoE}</p>
                            </div>
                        </div>

                        <h5 className='bg-secondary p-1 rounded-3 text-light mt-4 d-flex align-items-center justify-content-between'><span><FontAwesomeIcon icon={faTruck} /> Informações Sobre a Empresa de Coleta dos Resíduos</span></h5>
                        <div className="row">
                            <TabelaListagemFichas scrollbar={false} headers={headersTabelaTransportadores} items={pgrss.transportadores} />
                        </div>
                        <div className="contentGroup">
                            <div className="my-4 pt-4 text-center">
                                <p className='my-4 py-2  fw-bold'>DECLARO, SOB AS PENAS DA LEI, QUE AS INFORMAÇÕES PRESTADAS ACIMA SÃO VERDADEIRAS</p>
                            </div>
                            <div className="my-4 pt-2 text-center">
                                <p className="my-4">
                                    ____/____/_____
                                </p>
                            </div>
                            <div className="my-4 pt-2 text-center">
                                <p className="my-4 pb-2">
                                    ____________________________________________________________________
                                </p>
                            </div>
                            <div className="my-4 pb-2 text-center">
                                <p className="my-4 ">
                                    ____________________________________________________________________
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </MainCard >
    )
}